<ng-container [ngSwitch]="btnType">
	<ng-template *ngSwitchDefault [ngTemplateOutlet]="filled"></ng-template>
	<ng-template *ngSwitchCase="buttonType.STROKED" [ngTemplateOutlet]="stroked"></ng-template>
	<ng-template *ngSwitchCase="buttonType.BASIC" [ngTemplateOutlet]="basic"></ng-template>
	<ng-template *ngSwitchCase="buttonType.ICON" [ngTemplateOutlet]="icon"></ng-template>
	<ng-template *ngSwitchCase="buttonType.MINI_FAB" [ngTemplateOutlet]="miniFab"></ng-template>
</ng-container>

<!-- FILLED -->
<ng-template #filled>
	<ng-template [ngIf]="svgIcon" [ngIfElse]="defaultButton">
		<button
			mat-flat-button
			class="v2 c-btn c-btn--filled text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[type]="type"
			[disabled]="isDisabled"
			[disableRipple]="disableRipple"
			(click)="onClick($event)"
		>
			<mat-icon class="mat-icon-rtl-mirror" [svgIcon]="svgIcon"></mat-icon>
			{{ label }}
		</button>
	</ng-template>

	<ng-template #defaultButton>
		<button
			mat-flat-button
			class="v2 c-btn c-btn--filled text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[type]="type"
			[disabled]="isDisabled"
			[disableRipple]="disableRipple"
			[debounceTime]="debounceTime"
			(onEvent)="onClick($event)"
			appDebounceClick
		>
			<!-- Loader -->
			<mat-icon *ngIf="hasSpinner && isLoading">
				<mat-spinner diameter="20"></mat-spinner>
			</mat-icon>

			{{ label }}
		</button>
	</ng-template>
</ng-template>

<!-- STROKED -->
<ng-template #stroked>
	<ng-template [ngIf]="svgIcon" [ngIfElse]="defaultButton">
		<button
			mat-stroked-button
			class="v2 c-btn c-btn--stroked text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[type]="type"
			[disabled]="isDisabled"
			[disableRipple]="disableRipple"
			(click)="onClick($event)"
		>
			<mat-icon [svgIcon]="svgIcon"></mat-icon>
			{{ label }}
		</button>
	</ng-template>

	<ng-template #defaultButton>
		<button
			mat-stroked-button
			class="v2 c-btn c-btn--stroked text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[disabled]="isDisabled"
			[disableRipple]="disableRipple"
			(click)="onClick($event)"
		>
			{{ label }}
		</button>
	</ng-template>
</ng-template>

<!-- BASIC -->
<ng-template #basic>
	<ng-template [ngIf]="svgIcon" [ngIfElse]="defaultButton">
		<button
			mat-button
			class="v2 c-btn c-btn--basic text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[type]="type"
			[disabled]="isDisabled"
			[disableRipple]="true"
			(click)="onClick($event)"
		>
			<mat-icon [svgIcon]="svgIcon"></mat-icon>
			{{ label }}
		</button>
	</ng-template>

	<ng-template #defaultButton>
		<button
			mat-button
			class="v2 c-btn c-btn--basic text-truncate"
			color="primary"
			[id]="id"
			[ngClass]="customClass"
			[class.disabled]="isDisabled"
			[class.disabled-ripple]="disableRipple"
			[type]="type"
			[disabled]="isDisabled"
			[disableRipple]="disableRipple"
			(click)="onClick($event)"
		>
			{{ label }}
		</button>
	</ng-template>
</ng-template>

<!-- ICON -->
<ng-template #icon>
	<button
		mat-icon-button
		class="v2 c-btn--icon"
		[id]="id"
		[ngClass]="customClass"
		[class.disabled]="isDisabled"
		[class.disabled-ripple]="disableRipple"
		[type]="type"
		[disabled]="isDisabled"
		(click)="onClick($event)"
	>
		<mat-icon [svgIcon]="svgIcon"></mat-icon>
	</button>
</ng-template>

<!-- MINI-FAB -->
<ng-template #miniFab>
	<button
		mat-mini-fab
		color="primary"
		[id]="id"
		[ngClass]="customClass"
		[class.disabled]="isDisabled"
		[class.disabled-ripple]="disableRipple"
		[type]="type"
		[disabled]="isDisabled"
		(click)="onClick($event)"
	>
		<mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

		<ng-content select="[icon]"></ng-content>
	</button>
</ng-template>
